import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Couimg from "../assets/img/oneimg1.png";
import Couimgg from "../assets/img/oneimg2.png";
import Image1 from "../assets/img/courtest1.png";
import Image2 from "../assets/img/courtest4.png";
import Image3 from "../assets/img/courtest3.png";
import Image4 from "../assets/img/courtest2.png";

import Video1 from '../assets/video/video1.mp4';
import Video2 from '../assets/video/video2.mp4';
import Video3 from '../assets/video/video3.mp4';
import Video4 from '../assets/video/video4.mp4';
import Gmailicon from '../assets/img/gmail.png';
import Phoneicon from '../assets/img/phone.png';
import Playbtn from '../assets/img/play.png';

import onebg from '../assets/img/pageantbanner.png';
import onebg1 from '../assets/img/pageantsecond.png';
import onebg2 from '../assets/img/pageantright.png';
import Icon11 from '../assets/img/one/icon8.jpg';
import Icon1 from '../assets/img/about/skill1.png';
import Icon2 from '../assets/img/about/skill2.png';
import Icon3 from '../assets/img/about/skill3.png';
import Icon4 from '../assets/img/about/skill4.png';
import Icon31 from '../assets/img/about/skill5.png';
import Icon41 from '../assets/img/about/skill6.png';
import Icon411 from '../assets/img/about/sign.png';


import Icon311 from '../assets/img/about/one_1.png';
import Icon32 from '../assets/img/about/one_2.png';
import Icon33 from '../assets/img/about/one_3.png';
import Icon34 from '../assets/img/about/one_4.png';
import Icon35 from '../assets/img/about/one_5.png';

import Icon5 from '../assets/img/one/icon5.jpg';
import Icon6 from '../assets/img/one/icon6.jpg';
import Icon7 from '../assets/img/one/icon7.jpg';
import Icon8 from '../assets/img/one/icon8.jpg';
import Icon9 from '../assets/img/one/icon9.jpg';
import Icon51 from '../assets/img/icon51.png';
import Icon61 from '../assets/img/icon61.png';
import Icon71 from '../assets/img/icon71.png';
import Icon81 from '../assets/img/icon81.png';
import Icon91 from '../assets/img/icon91.png';

import imgch from '../assets/img/outcome.png';
import imgch1 from '../assets/img/one/bhavna.png';
import imgch2 from '../assets/img/one/image111.png';

import imgchh from '../assets/img/one/why.png';
import imgchhh from '../assets/img/one/why_light.png';
import Iconline from '../assets/img/one/line_why.png';
import iconprogram from '../assets/img/one/program.png';
import iconwork from '../assets/img/one/will_work.png';
import iconline from '../assets/img/one/happen_line.png';
import iconwill from '../assets/img/one/will_work_line.png';

import SeoHelmet from "../components/SeoHelmet";
import iconstrt from "../assets/img/iconstartt.png";
import staricon from '../assets/img/starbtn.png';
import staricon1 from '../assets/img/r_arrow.png';
import crown_icon from '../assets/img/one/crown.png';
import pageantt from '../assets/img/one/pageant1.png';
import outcrown from '../assets/img/outcome_crown.png';
import pageicon from '../assets/img/pageimg.png';
import pageicon1 from '../assets/img/pageantmo2.png';
import onebgmo from '../assets/img/pagemo3.png';
import outicon from '../assets/img/pagemo4.png';
import outicon1 from '../assets/img/pagemo5.png';

const Pageant = () => {

  useEffect(() => {
    document.body.classList.add('pageant-page');

    return () => {
      document.body.classList.remove('pageant-page');
    };
  }, []);

  const [activeVideo, setActiveVideo] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: ""
  });

 

  const handleOpenModal = (videoSrc) => {
    setActiveVideo(videoSrc); // Set the active video source
  };

  const handleCloseModal = () => {
    setActiveVideo(null); // Clear the active video source
  };




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };



  const handleRazorpayPayment = (courseType) => {

    if (!formData.name.trim()) {
      alert("Please enter your name.");
      return;
    }
    if (!formData.email.trim()) {
      alert("Please enter your email.");
      return;
    }
    if (!formData.phone.trim()) {
      alert("Please enter your phone number.");
      return;
    }
    const amount = courseType === "online" ? 50000 : 100000; // ₹500 for online, ₹1000 for offline
    const description = courseType === "online" ? "Online Course" : "Offline Course";

    const options = {
      key: "rzp_live_RqikICjLlTbO4w", // Replace with your Razorpay Key ID
      amount: amount * 100, // Amount in paise (1000 = ₹10)
      currency: "INR",
      name: "Bhavana Singh Courses",
      description: description,
      //image: "https://your-logo-url.com/logo.png", // Replace with your company logo URL
      handler: function (response) {
        const paymentId = response.razorpay_payment_id;
        //alert(`Payment successful. Payment ID: ${paymentId}`);
        window.location.href = `/success?payment_id=${paymentId}`;
      },
      prefill: {
        name: formData.name,
        email: formData.email,
        contact: formData.phone,
      },
      notes: {
        address: "Bhavana Singh",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const razorpay = new window.Razorpay(options);
    razorpay.on("payment.failed", function (response) {
      alert(`Payment failed. Error: ${response.error.description}`);
    });
    razorpay.open();
  };


  const courses = {
    1: {
      title: "First Post", content: (
        <>

        </>
      ),
    },
    2: {
      title: "Second Post", content: (
        <>


        </>
      ),
    },
  };





  useEffect(() => {

    if (window.Swiper) {



      const swiper = new window.Swiper(".coursesslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },
          },
          // You can add more breakpoints if needed
        },

      });


    }
  }, []);


  return (
    <>
      <SeoHelmet
        title="One-on-One Personality & Style Transformation | Bhavana Singh"
        description="Private one-on-one personality and style transformation by Bhavana Singh. Build confidence, presence, communication, and a powerful personal image"

      />

      <div className="mobilebanner">
        <div className="contentone_outer">
         <div className="title_one">
              <h5>You don't need to become someone else</h5>
              <h6>TO WIN A <span>-PAGEANT</span></h6>
            </div>
            </div>
      </div>
      <section className="oneofone_section one_on_one one_one pageant_sectionsss" style={{ backgroundImage: `url(${onebg})` }}>
        <div class="container">
          <div className="contentone_outer">
            <div className="title_one">
              <h5>You don't need to become someone else</h5>
              <h6>TO WIN A <span>-PAGEANT</span></h6>
            </div>
            <div className="skillbox skillboxx">
              <p>You need to become the most</p>
              <h2>Powerful, polished version of you</h2>
              <p>with the right guidance, structure, and stage training.</p><br></br>
              <p className="para2">This is a complete transformation under one roof, under my guidance.<br></br> From aesthetics to communication, from styling to stage presence <br></br>
                — every detail is curated for your pageant journey.</p>


            </div>

          </div>
          <div className="pageant_1">
            <h2>1.Aesthetics & Grooming</h2>
            <p>(Done with strategy, not trends)</p>
            <ul>
              <li>
                <img src={crown_icon} ></img>Hair colour guidance that suits your<br></br> undertone and pageant look
              </li>
              <li>
                <img src={crown_icon} ></img>Skin aesthetics planning (glow, texture,<br></br> routine, timelines)
              </li>
              <li>
                <img src={crown_icon} ></img>Personalised skincare routine + prep plan for<br></br> shoot & stage days
              </li>
              <li>
                <img src={crown_icon} ></img>Overall grooming checklist (hands, feet,<br></br> brows, posture-ready presentation)
              </li>

            </ul>
          </div>
        </div>
      </section>
      <section className="pageant_section">
        <div className="pageant_detail" style={{ backgroundImage: `url(${onebg1})` }}>
          <div className="pageant_1">

          </div>
          <div className="pageant_1">
            <h2>2.Communication,<br></br> Speech & Voice</h2>
            <ul>
              <li>
                <img src={crown_icon} ></img>Speech clarity + articulation training
              </li>
              <li>
                <img src={crown_icon} ></img>Voice modulation, pitch control, <br></br>pace, and pauses
              </li>
              <li>
                <img src={crown_icon} ></img>Answer framing for Q&A rounds <br></br>(structured, confident, impactful)
              </li>
              <li>
                <img src={crown_icon} ></img>Interview presence training (calm,<br></br> composed, memorable)
              </li>

            </ul>
          </div>
          <div className="pageant_1">
            <h2>3.Styling & Shopping</h2>
            <p>(Curated head-to-toe)</p>
            <ul>
              <li>
                <img src={crown_icon} ></img>Outfit direction for every pageant segment
              </li>
              <li>
                <img src={crown_icon} ></img>Shopping support + exact recommendations<br></br> (what to buy, what to avoid)
              </li>
              <li>
                <img src={crown_icon} ></img>Accessories, heels, innerwear,<br></br> shapewear — every detail covered
              </li>
              <li>
                <img src={crown_icon} ></img>Color palettes, silhouettes, fabrics that<br></br> flatter your body and personality
              </li>

            </ul>
          </div>
        </div>
        <div className="pageant_detail page_detail" style={{ backgroundImage: `url(${onebg2})` }}>

          <div className="pageant_1">
            <h2>4.Ramp Walk, Stage<br></br> Practice & Presence</h2>
            <ul>
              <li>
                <img src={crown_icon} ></img>Ramp training (walk patterns,<br></br> turns, expressions, balance)
              </li>
              <li>
                <img src={crown_icon} ></img>Stage presence: how to enter,<br></br> hold, and own the stage
              </li>
              <li>
                <img src={crown_icon} ></img>Body language building<br></br> (confidence, elegance, poise)
              </li>
              <li>
                <img src={crown_icon} ></img>Practice sessions + corrections<br></br> with camera feedback
              </li>

            </ul>
          </div>
          <div className="pageant_1">
            <h2>5.Confidence &<br></br> Personality Building</h2>
            <ul>
              <li>
                <img src={crown_icon} ></img>How to carry yourself in every room:<br></br> backstage to spotlight
              </li>
              <li>
                <img src={crown_icon} ></img>Grace under pressure, handling nerves, and<br></br> building stage confidence
              </li>
              <li>
                <img src={crown_icon} ></img>Personal brand polishing: energy, presence,<br></br> and signature style
              </li>


            </ul>
          </div>
          <div className="pageant_1">

          </div>
        </div>
        <div className="pageant_detail_mobile">
           <div className="pageant_1 pagee page111">
              <h2>1.Aesthetics & Grooming</h2>
            <p>(Done with strategy, not trends)</p>
            <ul>
              <li>
                <img src={crown_icon} ></img>Hair colour guidance that suits your<br></br> undertone and pageant look
              </li>
              <li>
                <img src={crown_icon} ></img>Skin aesthetics planning (glow, texture,<br></br> routine, timelines)
              </li>
              <li>
                <img src={crown_icon} ></img>Personalised skincare routine + prep plan for<br></br> shoot & stage days
              </li>
              <li>
                <img src={crown_icon} ></img>Overall grooming checklist (hands, feet,<br></br> brows, posture-ready presentation)
              </li>

            </ul>
          </div>
          <div className="pageant_mobile">
            <img className="pagemobi" src={pageicon} ></img>
          </div>
          <div className="pageant_mobile pageant_1">
            <h2>2.Communication,<br></br> Speech & Voice</h2>
            <ul>
              <li>
                <img src={crown_icon} ></img>Speech clarity + articulation training
              </li>
              <li>
                <img src={crown_icon} ></img>Voice modulation, pitch control, <br></br>pace, and pauses
              </li>
              <li>
                <img src={crown_icon} ></img>Answer framing for Q&A rounds <br></br>(structured, confident, impactful)
              </li>
              <li>
                <img src={crown_icon} ></img>Interview presence training (calm,<br></br> composed, memorable)
              </li>

            </ul>
          </div>
          <div className="pageant_mobile">
            <img src={pageicon1} ></img>
          </div>
          <div className="pageant_mobile pageant_1 pagebggg" style={{ backgroundImage: `url(${onebg2})` }}>
             <h2>3.Styling & Shopping</h2>
            <p>(Curated head-to-toe)</p>
            <ul>
              <li>
                <img src={crown_icon} ></img>Outfit direction for every pageant segment
              </li>
              <li>
                <img src={crown_icon} ></img>Shopping support + exact recommendations<br></br> (what to buy, what to avoid)
              </li>
              <li>
                <img src={crown_icon} ></img>Accessories, heels, innerwear,<br></br> shapewear — every detail covered
              </li>
              <li>
                <img src={crown_icon} ></img>Color palettes, silhouettes, fabrics that<br></br> flatter your body and personality
              </li>

            </ul>
          </div>
          <div className="pageant_mobile pageant_1 pagee" style={{ backgroundImage: `url(${onebgmo})` }}>
            <h2>4.Ramp Walk, Stage<br></br> Practice & Presence</h2>
            <ul>
              <li>
                <img src={crown_icon} ></img>Ramp training (walk patterns,<br></br> turns, expressions, balance)
              </li>
              <li>
                <img src={crown_icon} ></img>Stage presence: how to enter,<br></br> hold, and own the stage
              </li>
              <li>
                <img src={crown_icon} ></img>Body language building<br></br> (confidence, elegance, poise)
              </li>
              <li>
                <img src={crown_icon} ></img>Practice sessions + corrections<br></br> with camera feedback
              </li>

            </ul>
          </div>
          <div className="pageant_mobile pageant_1">
            <h2>5.Confidence &<br></br> Personality Building</h2>
            <ul>
              <li>
                <img src={crown_icon} ></img>How to carry yourself in every room:<br></br> backstage to spotlight
              </li>
              <li>
                <img src={crown_icon} ></img>Grace under pressure, handling nerves, and<br></br> building stage confidence
              </li>
              <li>
                <img src={crown_icon} ></img>Personal brand polishing: energy, presence,<br></br> and signature style
              </li>


            </ul>
          </div>

        </div>
        <div className="outcome_mobile">
          <div className="outcome_mobile_img"><img src={outicon}></img></div>
          <h2>Outcome You Can Expect</h2>
          <img src={outicon1}></img>
          <div className="outcome_ul">
            <div className="limited">
             <ul><li><img src={crown_icon} ></img>A clear personal style and stage identity</li></ul>
            </div>
            <div className="limited">
              <ul><li><img src={crown_icon} ></img>Stronger voice, sharper communication, confident Q&A</li></ul>
            </div>
            <div className="limited">
              <ul><li><img src={crown_icon} ></img>A walk and presence that looks trained, elegant, and powerful</li></ul>
            </div>
            <div className="limited">
              <ul><li><img src={crown_icon} ></img>A fully curated look head to toe built for spotlight moments</li></ul>
            </div>
            <div className="limited limit">
              <h3>Limited slots available</h3>
              <p>per pageant season.</p>
            </div>
          </div>
          
        </div>
         <div className="btngroup mobilebtn">

              <a
                href="#"
                data-bs-toggle="modal"
                className="terrs_btn"
                data-bs-target="#offlineCourseModal"
              >
                <img src={iconstrt} alt="" />
                ENROLL NOW
              </a>
            </div>
      </section>
      <section className="whycho one_whycho pageant_why">
        <div className="outcrown"><img className="imageonerr1" src={outcrown} ></img></div>
        <div className="onembr_row">
          <div className="imageoner">
            <img className="imageonerr1" src={imgch} ></img>
            <img className="imageonerr2" src={imgch2} ></img>

          </div>
          <div className="contentoner contentonerr">
            <h2>Outcome You Can Expect</h2>

            <ul>
              <li><span>A clear personal style and stage identity</span></li>
              <li><span>Stronger voice, sharper communication, confident Q&A</span></li>
              <li><span>A walk and presence that looks trained, elegant, and powerful</span></li>
              <li><span>A fully curated look head to toe built for spotlight moments</span></li>
            </ul>
            <div className="limited">
              <h4>Limited slots available</h4>
              <h5>per pageant season.</h5>
            </div>
            <div className="btngroup">

              <a
                href="#"
                data-bs-toggle="modal"
                className="terrs_btn"
                data-bs-target="#staticBackdrop"
              >
                <img src={iconstrt} alt="" />
                ENROLL NOW
              </a>
            </div>
            <div className="skillbox1">
              <img src={Icon411}></img>
              <div className="skillbox1_content">
                <h2>A private, personalised<br></br> journey designed only for you.</h2>
                <p>This is Bhavna Singh’s most exclusive<br></br> offering, created for individuals who want <br></br>focused attention, deep inner–outer work,<br></br> and complete confidentiality.</p>
              </div>
            </div>
          </div>
        </div>
      </section>








      <div className="modal fade" id="offlineCourseModal" tabIndex="-1" aria-labelledby="offlineCourseModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="formouter">
                <div className="formcontent">
                  <form className="contact_form modalform">
                    <h2>Pay for Offline Course</h2>
                    <div className="row">
                      <div className="col-sm-6">
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Your Name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Your Email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="number"
                          name="phone"
                          className="form-control"
                          placeholder="Your Phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-form"
                      onClick={() => handleRazorpayPayment("offline")}
                    >
                      Enrol Now
                    </button>
                  </form>
                </div>
                <div className="forminfo">
                  <a href="tel:919899604722">
                    <img src={Phoneicon} alt="" /> +91-9899604722
                  </a>
                  <a href="mailto:infobhavanasingh@gmail.com">
                    <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="onlineCourseModal" tabIndex="-1" aria-labelledby="onlineCourseModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="formouter">
                <div className="formcontent">
                  <form className="contact_form modalform">
                    <h2>Pay for Online Course</h2>
                    <div className="row">
                      <div className="col-sm-6">
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Your Name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Your Email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="number"
                          name="phone"
                          className="form-control"
                          placeholder="Your Phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-form"
                      onClick={() => handleRazorpayPayment("online")}
                    >
                      Enrol Now
                    </button>
                  </form>
                </div>
                <div className="forminfo">
                  <a href="tel:919899604722">
                    <img src={Phoneicon} alt="" /> +91-9899604722
                  </a>
                  <a href="mailto:infobhavanasingh@gmail.com">
                    <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div
        className={`modal fade ${activeVideo ? "show" : ""}`}
        id="videoModal"
        tabIndex="-1"
        aria-labelledby="videoModalLabel"
        aria-hidden={!activeVideo}
        style={{ display: activeVideo ? "block" : "none" }}
        onClick={(e) => {
          if (e.target.classList.contains("modal")) {
            handleCloseModal();
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered video_sectio">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="videoModalLabel">Bhavana Singh</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">
              {activeVideo && (
                <iframe
                  id="videoFrame"
                  width="100%"
                  height="500"
                  src={`${activeVideo}#t=0&autoplay=1`}
                  frameBorder="0"
                  allow="autoplay"
                  allowFullScreen
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Pageant;
